import { SimpleForm, Create } from "react-admin";

import { CreateToolbar } from "../../common/CreateToolbar";
import { ContentOriginSimpleFormContent } from "./components/ContentOriginSimpleFormContent";

export function ContentOriginCreate(): JSX.Element {
    return (
        <Create>
            <SimpleForm defaultValues={{ publicationDate: new Date() }} toolbar={<CreateToolbar />}>
                <ContentOriginSimpleFormContent />
            </SimpleForm>
        </Create>
    );
}
